(function ($) {
    $.fn.ikDynamicLoadService = function (settings) {
        var plugin = this,
            service = this,
            defaultSettings = {
                url: '',
                method: "POST",
                loadMoreButton: "#btn_load_more",
                setFilterAttr: 'data-set-filter',
                maxNumPagesAttr: 'data-max_num_pages',
                updateBoxClass: '',
                ajaxDefaultData: {
                    paged: 1
                }
            };

        var ikDynamicLoadService = function (element, options) {
            service = this;

            /** Init wrapper */
            service.element = $('body').find(element);

            /** Set service settings */
            service.settings = $.extend({}, defaultSettings, options);

            /** Set filters object */
            service.ajaxDataDefault = service.settings.ajaxDefaultData;
            service.ajaxData = service.settings.ajaxDefaultData;

            /** Set max number pages */
            service.maxNumPages = service.paginationController().getMaxNumPages();

            service.init();
        };

        /** Init service */
        ikDynamicLoadService.prototype.init = function () {
            /** Init set filters byt attr JSON */
            service.element.on('click', '[' + service.settings.setFilterAttr + ']', function (e) {
                var el = $(this),
                    params = service.helpers().paramsParser(el.attr(service.settings.setFilterAttr));

                if (el.is(':checked')) {
                    service.filtersController().set(params);
                } else {
                    service.filtersController().unset(params);
                }
            });

            /** Init */
            service.element.on('click', service.settings.loadMoreButton, function (e) {
                e.preventDefault();
                service.ajaxData.paged = service.ajaxData.paged + 1;
                service.paginationController().set(service.ajaxData.paged);
            });
        };

        /** Filter controller */
        ikDynamicLoadService.prototype.filtersController = function () {
            var setFilter = function (params) {
                switch (params.type) {
                    case 'value':
                        service.ajaxData.filters[params.name] = params.value;
                        break;
                    case 'array':
                        if (!params.name in service.ajaxData.filters) {
                            service.ajaxData.filters[params.name] = [];
                        }
                        service.ajaxData.filters[params.name].push(params.value);
                        break;
                }

                if (params.update){
                    service.helpers().beforeUpdate('list', false);
                    service.paginationController().reset();
                    service.filtersSend('replace');
                }
            };
            var unsetFilter = function (params) {
                switch (params.type) {
                    case 'value':
                        service.ajaxData.filters[params.name] = null;
                        break;
                    case 'array':
                        if (params.name in service.ajaxData.filters && service.ajaxData.filters[params.name].indexOf(params.value) >= 0) {
                            service.ajaxData.filters[params.name].splice(service.ajaxData.filters[params.name].indexOf(params.value), 1);
                        }
                        break;
                }
                if (params.update){
                    service.helpers().beforeUpdate('list', false);
                    service.paginationController().reset();
                    service.filtersSend('replace');
                }
            };
            var resetAll = function (update) {
                service.ajaxData.filters = service.ajaxDataDefault.filters;
                if (update){
                    service.helpers().beforeUpdate('list', false);
                    service.paginationController().reset();
                    service.filtersSend('replace');
                }
            };

            return {
                set: function (params) {
                    setFilter(params);
                },
                unset: function (params) {
                    unsetFilter(params);
                },
                reset: function () {
                    resetAll();
                }
            }
        };

        /** Load more controller */
        ikDynamicLoadService.prototype.paginationController = function () {
            return {
                getMaxNumPages: function () {
                    return parseInt(service.element.find(service.settings.loadMoreButton).attr(service.settings.maxNumPagesAttr));
                },
                set: function (page) {
                    service.ajaxData.paged = page;
                    service.helpers().beforeUpdate('button', false);
                    service.filtersSend('append');
                },
                update: function (page, maxNumPages) {
                    service.ajaxData.paged = page;
                    service.maxNumPages = maxNumPages;
                    service.paginationController().checkVisible();
                },
                checkVisible: function () {
                    if (service.maxNumPages == service.ajaxData.paged){
                        service.element.find(service.settings.loadMoreButton).hide();
                    } else {
                        service.element.find(service.settings.loadMoreButton).show();
                    }
                },
                reset: function () {
                    service.ajaxData.paged = 1;
                }
            }
        };

        /** Send filters */
        ikDynamicLoadService.prototype.filtersSend = function (event) {
            $.ajax({
                url: service.settings.url,
                method: service.settings.method,
                data: service.ajaxData
            }).done(function (response) {
                if (response.success) {
                    switch (event) {
                        case 'replace':
                            service.element.find(service.settings.updateBoxClass).html(response.data.html);
                            break;
                        case 'append':
                            service.element.find(service.settings.updateBoxClass).append(response.data.html);
                            break;
                    }
                    service.paginationController().update(response.data.paged, response.data.max_num_pages);
                }
            }).fail(function (error) {
                location.reload();
            }).always(function () {
                service.helpers().afterUpdate();
            });
        };

        /** Helpers */
        ikDynamicLoadService.prototype.helpers = function () {
            return {
                paramsParser: function (params) {
                    if (typeof params == "string") {
                        return JSON.parse(params.replace(new RegExp("'", "g"), '"'));
                    } else {
                        return params;
                    }
                },
                beforeUpdate: function (element, scroll) {
                    if (element == 'button'){
                        service.element.find(service.settings.loadMoreButton).addClass('btn-preloader');
                        service.element.find(service.settings.loadMoreButton).prepend(env.ajaxPreloader);
                    } else {
                        service.element.find(service.settings.updateBoxClass).prepend('<div class="dynamic-loader">' + env.ajaxPreloader + '</div>');
                    }
                    if (scroll){
                        $('html, body').animate({
                            scrollTop: service.element.find(service.settings.updateBoxClass).offset().top
                        }, 600);
                    }
                },
                afterUpdate: function () {
                    service.element.find(service.settings.loadMoreButton).removeClass('btn-preloader');
                    service.element.find(service.settings.loadMoreButton).find('.loader').remove();
                    service.element.find(service.settings.updateBoxClass).find('.dynamic-loader').remove();
                }
            }
        };

        var serviceInit = new ikDynamicLoadService(plugin, settings);
        serviceInit.filtersMethods = service.filtersController();

        return serviceInit;
    };
})(jQuery);